import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * A rule.
 *
 * Implemented natively rather than over @radix-ui/react-separator, which is
 * not a dependency of this project. The accessible semantics are the same:
 * decorative separators are hidden from the tree, semantic ones expose
 * role="separator" with an orientation.
 */
export interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: "horizontal" | "vertical";
  decorative?: boolean;
}

const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(
  ({ className, orientation = "horizontal", decorative = true, ...props }, ref) => (
    <div
      ref={ref}
      {...(decorative
        ? { role: "none" }
        : { role: "separator", "aria-orientation": orientation })}
      className={cn(
        "shrink-0 bg-border",
        orientation === "horizontal" ? "h-px w-full" : "h-full w-px",
        className,
      )}
      {...props}
    />
  ),
);
Separator.displayName = "Separator";

export { Separator };
